import {
  Button,
  Helper,
  Icon,
  ImageContainer,
  TextField,
  TruncateToolTip,
} from 'Components';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import NoImageFound from 'src/assets/NoImage.jpg';
import NoImageFoundFR from 'src/assets/NoImage_F.jpg';
import './ProductGridView.css';

const ProductGridView = (props) => (
  <div className="product-grid-view" key={props.key}>
    {!props.isCartSelected && props.isPinable && (
      <Helper text={i18n.t('tutorials:orders.star')}>
        <Button onClick={props.onStarClick}>
          <Icon icon={props.Pinned ? 'star' : 'star_border'} />
        </Button>
      </Helper>
    )}
    <ImageContainer
      alt={props.PortalDescription}
      src={props.PortalPictureFileName}
      fallbackImage={i18n.language === 'E' ? NoImageFound : NoImageFoundFR}
    />
    <div className="product-grid-view__details">
      <span>
        <TruncateToolTip text={props.PortalDescription} maxLength={50} />
      </span>
      <div>
        <span>{i18n.t('formsSupplies:Size')}:</span>
        <span>{props.Size}</span>
      </div>
      <div>
        <span>{i18n.t('formsSupplies:Type')}:</span>
        <span> {props.ItemType}</span>
      </div>
      <div>
        <span>{i18n.t('formsSupplies:Preservative')}:</span>
        <span>
          <TruncateToolTip text={props.Preservatives} maxLength={13} />
        </span>
      </div>
    </div>
    <div className="product-grid-view__buttons">
      {props.isCartSelected || !props.isInCart ? (
        <Helper text={i18n.t('tutorials:orders.quantity')}>
          <TextField
            onKeyPress={(e) => {
              if (e.key === 'Enter') e.preventDefault();
            }}
            placeholder={i18n.t('formsSupplies:Quantity')}
            type="number"
            value={props.quantity}
            onChange={props.onQuantityChange}
            hasError={props.hasQuantityError}
            isOnlyNumbers
          />
        </Helper>
      ) : (
        <div className="product-grid-view__buttons__placeholder" />
      )}
      <Button className="button--secondary" onClick={props.onSubmit}>
        {props.buttonText}
      </Button>
    </div>
  </div>
);

ProductGridView.propTypes = {
  key: PropTypes.string,
  quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  buttonText: PropTypes.string,
  onStarClick: PropTypes.func,
  onQuantityChange: PropTypes.func,
  onSubmit: PropTypes.func,
  Pinned: PropTypes.bool,
  PortalDescription: PropTypes.string,
  PortalPictureFileName: PropTypes.string,
  Size: PropTypes.string,
  ItemType: PropTypes.string,
  isInCart: PropTypes.bool,
  isCartSelected: PropTypes.bool,
  Preservatives: PropTypes.string,
  hasQuantityError: PropTypes.string,
  isPinable: PropTypes.bool,
};

ProductGridView.defaultProps = {
  Preservatives: 'Not Available',
  PortalDescription: '',
  PortalPictureFileName: NoImageFound,
};

export default ProductGridView;



// WEBPACK FOOTER //
// ./src/components/ProductGridView/ProductGridView.jsx